// extracted by mini-css-extract-plugin
export default {"editFeedbackContainer":"EditFeedback_editFeedbackContainer__NGv0c","editFeedback":"EditFeedback_editFeedback__IvldU","actions":"EditFeedback_actions__6ASLY"};